import { AppContent } from '../AppContent';
import { IDV_CAPTURE_SELFIE_PATH } from '../../utils/constant';

const idvErrorPage: AppContent['idvErrorPage'] = {
  idvErrorPageContent: [
    {
      serviceName: 'Online for Business',
      header: 'Something’s gone wrong on our end',
      errorText:
        'We’re having trouble completing your request. Please try again.',
      btnLabel: 'Try again',
      btnLink: IDV_CAPTURE_SELFIE_PATH,
    },
  ],
};

export default idvErrorPage;
